import { post } from './';
import { CLIENT_ID } from '../constants';

export const login = payload =>
  post(`/api/v1/oauth/token`, {
    ...payload,
  });

export const refreshToken = () =>
  post(`/api/v1/oauth/token`, {
    refreshToken: localStorage.getItem('refreshToken'),
  });

export const signUp = payload =>
  post(`/api/v1/auth/signup`, {
    ...payload,
  });

export const revokeToken = async (impersonating = false) => {
  await post('/api/v1/oauth/revoke-token', {
    token: impersonating
      ? localStorage.getItem('impersonationToken')
      : localStorage.getItem('accessToken'),
    clientId: CLIENT_ID,
  });
};

export const tokenIntrospection = async (impersonating = false) => {
  const response = await post('/api/v1/oauth/introspect', {
    token: impersonating
      ? localStorage.getItem('impersonationToken')
      : localStorage.getItem('accessToken'),
    clientId: CLIENT_ID,
  });
  return Boolean(response);
};
